const TIME_PATTERN = /\b\d{1,2}:\d{2}\b/

function getFirstTime(input: string): string {
  const match = TIME_PATTERN.exec(input)
  return match ? match[0] : ''
}

export default getFirstTime
